import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=6f1831cc&scoped=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=6f1831cc&prod&scoped=true&lang=css"
import style1 from "./PrivacyPolicy.vue?vue&type=style&index=1&id=6f1831cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1831cc",
  null
  
)

export default component.exports